<template>
  <a-cascader
    v-model="typeArr"
    :options="typeList"
    :load-data="loadData"
    placeholder="请选择动物类型"
    change-on-select
    @change="onChange"
    :allowClear="clearble"
  />
</template>
<script >
export default {
  props: ['feild','setFirst','clearble'],
  data() {
    return {
      typeArr: [],
      typeList: [],
      setFirstFlag: true
    }
  },
  mounted(){
    this.getTypeList({})
  },
  methods: {
    onChange(val){
      let value = val ? val[val.length - 1] : undefined
      this.$emit('setVal',{[this.feild]: value})
    },
    loadData(selectedOptions) {
      const targetOption = selectedOptions[selectedOptions.length - 1];
      targetOption.loading = true;
      setTimeout(() => {
        targetOption.loading = false;
        console.log('targetOption.id',targetOption.id)
        this.getTypeList({parentId: targetOption.id,record: targetOption}) || []
      }, 0);
    },
    getTypeList({parentId=0,record}){
      let factoryId = window.localStorage.getItem('factoryId')
      this.$get(`/iot-factory/FactoryAnimal/listByParentId?parentId=${parentId}&factoryId=${factoryId}`)
      .then(res => {
        let {success,data=[]} = res;
        if(success){
          data && data.map(el => {
            // el.value = el.id + '#####' + el.name
            el.value = el.id
            el.label = el.name
            el.isLeaf = !el.hasChildren
            return el
          })
          if(this.hasFirst){
            if(record){
              if(data.length){
                record.children = data
              }else {
                record.isLeaf = true
              }
              this.typeList = [...this.typeList];
            }else{
              this.typeList = data
            }
          }else{
            if(record){
              if(data.length){
                record.children = data
                if(this.setFirstFlag){
                  this.typeArr = [parentId,data[0].id]
                  this.$emit('setVal',{[this.feild]: data[0].id})
                  this.setFirstFlag = false
                }
              }else {
                record.isLeaf = true
              }
              this.typeList = [...this.typeList];
            }else{
              if(data && data.length > 0){
                let target = data[0] || {}
                if(parentId != 0){
                  this.typeList = data || []
                  if(this.setFirst){
                    this.getTypeList({parentId: this.typeList[0].id,record: this.typeList[0]}) || []
                    this.setFirstFlag = true
                  }
                }else{
                  this.getTypeList({parentId: target.id}) || []
                }
              }
              
            }
          }
          
        }else{
          this.typeList = []
        }
      })
    },
  }
}
</script>